module.exports = __webpack_public_path__ + "9e6ec35b55d2a5d6b8e96427645c943d.png";